import { translate } from '@jsverse/transloco';
import { finalize, Observable, take, takeUntil } from 'rxjs';
import { NotificationService } from 'vcp-common-ui-lib';

export type RunExportRequestOptions<T> = {
    notificationService: NotificationService;
    setLoading: (loading: boolean) => void;
    errorMessage: string;
    successMessage?: string;
    generatingMessage?: string;
    showGenerating?: boolean;
    showError?: boolean;
    successInFinalize?: boolean;
    teardown$?: Observable<unknown>;
    onSuccess?: (value: T) => void;
};

export function runExportRequest<T>(request$: Observable<T>, options: RunExportRequestOptions<T>): void {
    const {
        notificationService,
        setLoading,
        errorMessage,
        successMessage,
        generatingMessage,
        showGenerating = true,
        showError = true,
        successInFinalize = false,
        teardown$,
        onSuccess,
    } = options;

    setLoading(true);
    if (showGenerating) {
        notificationService.info(generatingMessage ?? translate('COMMON_UI.GENERATING_EXPORT'));
    }

    const bound$ = teardown$ ? request$.pipe(takeUntil(teardown$)) : request$.pipe(take(1));

    bound$
        .pipe(
            finalize(() => {
                setLoading(false);
                if (successInFinalize && successMessage) {
                    notificationService.success(successMessage);
                }
            })
        )
        .subscribe({
            next: (value) => {
                onSuccess?.(value);
                if (!successInFinalize && successMessage) {
                    notificationService.success(successMessage);
                }
            },
            error: () => {
                if (showError) {
                    notificationService.error(errorMessage);
                }
            },
        });
}
